const BackgroundOrbs = ({ ...rest }) => (
  <div
    className="absolute inset-0 overflow-hidden pointer-events-none"
    aria-hidden="true"
    {...rest}
  >
    <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-md-electric/8 blur-3xl" />
    <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-md-cyan/6 blur-3xl" />
    <div className="absolute top-1/3 right-0 w-[500px] h-[500px] rounded-full bg-indigo-900/20 blur-3xl" />
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-md-blue/5 blur-3xl" />
  </div>
);

export default BackgroundOrbs;
